import { render, staticRenderFns } from "./CreatePackage.vue?vue&type=template&id=002eae80&scoped=true&"
import script from "./CreatePackage.vue?vue&type=script&lang=js&"
export * from "./CreatePackage.vue?vue&type=script&lang=js&"
import style0 from "./CreatePackage.vue?vue&type=style&index=0&id=002eae80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002eae80",
  null
  
)

export default component.exports